import { useEffect, useRef } from 'react';
import { BlockType, SwitchBlock } from '../switchBlock/SwitchBlock';
import style from './StandardBlocksLayout.module.scss';
type Props = { blocks: BlockType[]; blockStyles?: string };

export const StandardBlocksLayout = ({ blocks, blockStyles }: Props): JSX.Element => {
  return (
    <>
      {blocks.map((block, index) => {
        const nextBlock = blocks[index + 1];

        const sectionState = block.block_type !== 'gallery' ? style.gutter : null;

        const nextBlockIsSame = nextBlock
          ? nextBlock.block_type === block.block_type
            ? 'nextBlockIsSame'
            : ''
          : '';

        return (
          <section
            key={index}
            className={`blocks ${style.section} ${sectionState} ${style.blocks} ${blockStyles} block-content-${block.block_type} ${nextBlockIsSame}`}
          >
            <SwitchBlock block={block} />
          </section>
        );
      })}
    </>
  );
};
